import React, { useState, useEffect } from 'react';
import MovieCard from './MovieCard';
import { useToast } from './Toast';
import api from '../services/api';

export default function Watchlist({ user, onWatchlistChange, setActiveTab }) {
  const [watchlist, setWatchlist] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    api.getWatchlist()
      .then(d => {
        const sorted = (d.watchlist || []).slice().sort((a, b) => {
          // On-sale movies first
          if (a.tickets_on_sale && !b.tickets_on_sale) return -1;
          if (!a.tickets_on_sale && b.tickets_on_sale) return 1;
          // Then by release date ascending, TBA last
          if (!a.release_date) return 1;
          if (!b.release_date) return -1;
          return a.release_date < b.release_date ? -1 : 1;
        });
        setWatchlist(sorted);
      })
      .catch(() => toast('Failed to load watchlist', 'error'))
      .finally(() => setLoading(false));
  }, [user]);

  async function handleRemove(movieId) {
    try {
      await api.removeFromWatchlist(movieId);
      setWatchlist(prev => prev.filter(m => m.id !== movieId));
      toast('Removed from watchlist', 'info');
      onWatchlistChange(movieId, false);
    } catch (err) {
      toast(err.message, 'error');
    }
  }

  const firstName = user?.name?.split(' ')[0] || 'there';

  return (
    <div className="watchlist-page">

      {/* ── Header ── */}
      <div className="watchlist-header">
        <div className="watchlist-header-eyebrow">🔔 Alert Dashboard</div>
        <h2 className="watchlist-header-title">My Watchlist</h2>
        {!loading && (
          <p className="watchlist-header-sub">
            {watchlist.length === 0
              ? `Hey ${firstName}, add some movies to get started.`
              : <>Hey {firstName} — we're watching <strong className="wl-count">{watchlist.length} movie{watchlist.length !== 1 ? 's' : ''}</strong> for you.</>}
          </p>
        )}
      </div>

      {/* ── Content ── */}
      {loading ? (
        <div className="spinner-wrap" style={{ height: 300 }}>
          <div className="spinner" />
        </div>
      ) : watchlist.length === 0 ? (
        <div className="wl-empty">
          <div className="wl-empty-icon">🎬</div>
          <h3 className="wl-empty-title">Your watchlist is empty</h3>
          <p className="wl-empty-sub">
            Browse upcoming movies and click <strong>Alert Me</strong> — we'll notify you the moment tickets go on sale.
          </p>
          <button
            className="btn btn-primary btn-lg"
            onClick={() => setActiveTab('coming_soon')}
          >
            Browse Movies
          </button>
        </div>
      ) : (
        <div className="watchlist-grid">
          {watchlist.map(movie => (
            <div
              key={movie.id}
              className={`watchlist-card-wrap${!!movie.tickets_on_sale ? ' watchlist-card-wrap--on-sale' : ''}${!!movie.notified ? ' watchlist-card-wrap--notified' : ''}`}
            >
              {!!movie.tickets_on_sale && (
                <div className="watchlist-on-sale-badge">🎟 TICKETS ON SALE</div>
              )}
              {/* ✓ notified badge — fix: !!movie.notified guards against DB integer 0 rendering */}
              {!!movie.notified && !movie.tickets_on_sale && (
                <div className="watchlist-notified-badge">✓ Alerted</div>
              )}
              <MovieCard
                movie={movie}
                inWatchlist={true}
                onWatchlistToggle={(id) => handleRemove(id)}
                isLoggedIn={true}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
